import React from "react";
import { useNavigate } from "react-router-dom";
import "../../style/css/AppointmentBooking.css";
import { HeaderLanding } from "../HeaderLanding";

interface ProfessionalNotFoundErrorProps {
  message?: string;
  onRetry?: () => void;
  onGoBack?: () => void;
  searchTerm?: string;
}

const ProfessionalNotFoundError: React.FC<ProfessionalNotFoundErrorProps> = ({
  message = "Lo sentimos, no pudimos encontrar al profesional que buscas.",
  onRetry,
  onGoBack,
  searchTerm,
}) => {
  const navigate = useNavigate();
  const handleTryFree = () => {
    navigate("/#register");
  };
  return (
    <div>
      <HeaderLanding onTryFree={handleTryFree} showLoginButton={true} />
      <div className="error-container">
        {/* Icono de error */}
        <div className="error-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-1.72 6.97a.75.75 0 10-1.06 1.06L10.94 12l-1.72 1.72a.75.75 0 101.06 1.06L12 13.06l1.72 1.72a.75.75 0 101.06-1.06L13.06 12l1.72-1.72a.75.75 0 10-1.06-1.06L12 10.94l-1.72-1.72z"
              clipRule="evenodd"
            />
          </svg>
        </div>

        {/* Título */}
        <h3 className="error-title">Profesional no encontrado</h3>

        {/* Mensaje personalizado */}
        <p className="error-message">
          {message}
          {searchTerm && (
            <span style={{ display: "block", marginTop: "0.5rem" }}>
              Búsqueda: <strong>{searchTerm}</strong>
            </span>
          )}
        </p>

        {/* Acciones */}
        <div className="error-actions">
          {onRetry && (
            <button className="btn btn--primary" onClick={onRetry}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ marginRight: "8px" }}
              >
                <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.3" />
              </svg>
              Intentar de nuevo
            </button>
          )}

          {onGoBack && (
            <button className="btn btn--secondary" onClick={onGoBack}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{ marginRight: "8px" }}
              >
                <path d="M19 12H5M12 19l-7-7 7-7" />
              </svg>
              Volver atrás
            </button>
          )}
        </div>

        {/* Información adicional */}
        <p
          style={{
            fontSize: "0.875rem",
            color: "var(--neutral-300)",
            marginTop: "var(--space-lg)",
            maxWidth: "400px",
          }}
        >
          <strong>Sugerencias:</strong>
          <br />
          • Verifica la ortografía del nombre
          <br />
          • Intenta con términos de búsqueda más generales
          <br />• Revisa nuestra lista completa de profesionales
        </p>
      </div>
    </div>
  );
};

export default ProfessionalNotFoundError;
